class AmazonInventoryMonthlyCanCreateResponseDto {
  /** 是否可以创建FBA月度盘点 */
  canCreate = false;
}

class ApprovalBeforeRequestDto {
  /** 业务Key，例如盘点单号 */
  businessKey = "";

  /** 页大小 */
  pageNumber = undefined;

  /** 页号 */
  pageSize = undefined;

  /** 流程定义key,盘点：InventoryApproval */
  processKey = "";
}

class ApprovalFlowModel {
  /** 审核状态  -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = undefined;

  /** 审批时间 */
  approveTime = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 审批人 */
  currentApproval = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 工作流实例ID */
  instanceId = "";

  /** 版本 */
  lockVersion = undefined;

  /** 流程key */
  processKey = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ApprovalRequestDto {
  /** 审批状态：待提交：-1，已驳回：0；已通过<流程结束传>：1；审批中<只要流程没结束都是传该状态>：2；已撤回：3 ；已挂起：4；已删除：5；流程终止：-2 */
  approvalStatus = undefined;

  /** 审批意见 */
  approvalSug = "";

  /** 审批流程号 */
  businessKey = "";

  /** 表单数据 */
  formData = undefined;

  /** 本次操作 */
  operateTaskDto = new CurrentTaskDto();

  /** 流程实例id */
  processInstanceId = "";

  /** 流程定义key */
  processKey = "";

  /** 是否需要开启审批流 */
  startApproval = false;

  /** 驳回目标节点 */
  taskDto = new TaskDto();
}

class AssigneeDto {
  /** 操作人内部编号 */
  userCode = "";

  /** 操作人名称 */
  userName = "";
}

class BatchCreateRequestParamsDto {
  /** 箱数 */
  boxNum = undefined;

  /** 交货模式 */
  deliveryMode = "";

  /** 交货单单据No(母交货单NO) */
  dono = "";

  /** 预计到货时间 */
  estimateTime = "";

  /** 是否历史订单 默认false，不是历史订单不需要传该参数，是则传ture */
  historyOrder = false;

  /** 入库-行-箱 */
  inDeliveryLineBoxRequestParamsList = [];

  /** 入库-采购交货行 */
  inDeliverySkuLineRequestParamsDtoList = [];

  /** 入库类型,2-换货入库，1-维修入库，-1-退货入库 */
  inboundType = undefined;

  /** inspectionType */
  inspectionType = undefined;

  /** 包裹明细 */
  omsPackageInfoDtos = [];

  /** 订单子类型，1-平台订单,5-京配订单,6-京东自营订单 */
  orderChildType = undefined;

  /** 计划入库数量 */
  planQty = undefined;

  /** 平台编号 */
  platformCode = "";

  /** 采购单号 */
  pono = "";

  /** 采购员 */
  purchaser = "";

  /** 备注 */
  remark = "";

  /** 退货单号 */
  returnOrderId = "";

  /** 入库SKU明细 */
  skuList = [];

  /** 订单编号 */
  soOrderNo = "";

  /** 来源子类型 1:采购入库 2:FBA调拨 3:WFS调拨 4:三方调拨 5:自营调拨 6:搬仓调拨 7:WFS调拨 8:调拨物流退件 9:销售物流退件 10:销售退货 */
  sourceChildType = undefined;

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 5:交货单 6:退货入库 7:调拨入库 8:借调入库 9:销售渠道退件入库 10:调拨渠道退件入库 11:批量交货单 12:手动创建移除货件 20:公司间交易 22:OMS售后单 */
  sourceType = undefined;

  /** 供应商编号 */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 是否含税 0:否1:是 */
  taxFlag = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 运单号 */
  waybillNo = "";
}

class BatchMasterCreateRequestParamDto {
  /** 箱号 */
  boxNo = "";

  /** 箱高 */
  height = undefined;

  /** 箱长 */
  length = undefined;

  /** MPQ，每箱数量 */
  mpq = undefined;

  /** 数量 */
  qty = undefined;

  /** sku */
  skuNo = "";

  /** 箱宽 */
  width = undefined;
}

class BatchStockAgeResponseRpcDto {
  /** 批次号 */
  batchNo = "";

  /** 入库时间 */
  inTime = "";

  /** 来源单号 */
  sourceNo = "";
}

class BoxRequestDto {
  /** 批次单号列表 */
  batchNoList = [];

  /** 箱号列表 */
  boxNoList = [];
}

class CurrentTaskDto {
  /** 节点当前处理人 */
  currentAssignee = new AssigneeDto();

  /** 节点编码 */
  nodeKey = "";

  /** 节点名称 */
  nodeName = "";

  /** 节点操作类型 驳回指定节点:backToStart；驳回:reject；通过:pass,；反对：oppose；弃权：abandon；终止：cadence */
  operate = "";

  /** 任务id */
  taskId = "";
}

class DeliveryDealRequestDto {
  /** 采购行详情 */
  deliveryDealRowDetailList = [];

  /** 入库退/出库单号 */
  masterId = "";

  /** 采购入库计划单id */
  planId = "";

  /** 来源系统 */
  sourceSystem = "";

  /** 供应商编号 */
  supplierCode = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 事务类型 */
  transactionType = undefined;

  /** 入库/退货日期 */
  wareHouseTime = "";

  /** 仓库编号 */
  warehouseCode = "";
}

class DeliveryDealRowDetail {
  /** 采购订单号 */
  pono = "";

  /** 采购价 */
  purchasePrice = undefined;

  /** 采购员 */
  purchaser = "";

  /** 数量 */
  qty = undefined;

  /** 采购订单行号 */
  rowNo = "";

  /** sku编号 */
  skuNo = "";
}

class EbsOutputParameters {
  /** xmsgData */
  xmsgData = "";

  /** xresultRec */
  xresultRec = new XResultRec();

  /** xreturnStatus */
  xreturnStatus = "";
}

class EbsSkuCostDto {
  /** 库存成本 */
  acCost = "";

  /** 币种 */
  currency = "";

  /** itemCode */
  itemCode = "";

  /** 物流成本 */
  logAcCost = "";
}

class EbsSkuCostListDto {
  /** skuCostDtoList */
  skuCostDtoList = [];

  /** warehouseCode */
  warehouseCode = "";
}

class EbsTransferDataResponseDto {
  /** outputParameters */
  outputParameters = new EbsOutputParameters();
}

class FilterRuleBean {
  /** 缺货时是否匹配所有仓库：1是 0否 */
  isAllWarehouses = undefined;

  /** 是否优先FBA发货：1是 0否 */
  isFbaFirst = undefined;

  /** 是否启用价格范围左：1是 0否 */
  isPriceRangeLeft = undefined;

  /** 是否启用价格范围右：1是 0否 */
  isPriceRangeRight = undefined;

  /** 价格范围左符号： >大于, >=大于等于, =等于 */
  priceRangeLeftSymbol = "";

  /** 价格范围左金额 */
  priceRangeLeftValue = undefined;

  /** 价格范围右符号： <小于, <=小于等于 */
  priceRangeRightSymbol = "";

  /** 价格范围右金额 */
  priceRangeRightValue = undefined;

  /** 匹配SKU */
  sku = [];

  /** 匹配仓库 */
  warehouses = [];

  /** 分区集合 */
  zones = [];
}

class FulfilmentInRequestDto {
  /** 自定义履行时间 */
  customizeDeliveryTime = "";

  /** 默认全量入库 */
  inAll = false;

  /** 入库计划-明细 */
  inPlanDetailFulfilmentRequestParamsDtoList = [];

  /** 入库上架明细 */
  inPutDetailDtoList = [];

  /** 操作单号 入库计划单或者库存调整单 */
  operationNo = "";

  /** 来源操作订单类型 1:入库计划单,2:出库计划单,3:库存调整单 */
  operationOrderType = undefined;

  /** 供应商交货POD文件名 */
  podFileName = "";

  /** 供应商交货POD文件 */
  podFileUrl = "";

  /** 备注 */
  remark = "";

  /** 来源单号 */
  sourceNo = "";

  /** 来源子库编码,调拨入库需要 */
  sourceWarehouseCode = "";
}

class FulfilmentOutRequestDto {
  /** 入库单号，需要生成入库计划单并关联入库单（自营仓发出去的的调拨类型需要） */
  iono = "";

  /** 操作单号 出库计划单或者库存调整单 */
  operationNo = "";

  /** 来源操作订单类型 1:入库计划单,2:出库计划单,3:库存调整单 */
  operationOrderType = undefined;

  /** 出库拣货明细 */
  outPickDetailDtoList = [];

  /** 出库计划-明细 */
  outPlanDetailFulfilmentRequestParamsDtoList = [];

  /** 备注 */
  remark = "";

  /** 来源单号 */
  sourceNo = "";

  /** 平台编号 */
  targetPlatformCode = "";

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 调入交易主体编号 */
  tradeCompanyInCode = "";

  /** 调入交易主体名称 */
  tradeCompanyInName = "";
}

class FulfilmentResponseRpcDto {
  /** 调拨出库/调拨入库/调拨退货; 阈值：TRANSFER_OUT-调拨出库；TRANSFER_IN-调拨入库；TRANSFER_RETURN-调拨退回 */
  businessType = "";

  /** 一级部门编号 */
  deptId = "";

  /** 履行时间 */
  fulfilmentTime = "";

  /** 出入库单号 */
  insideOperationNo = "";

  /** 入库计划单（调拨类型有返回） */
  ipno = "";

  /** EBS杂项类型 */
  miscellaneousType = "";

  /** 操作单号，出库计划单，入库计划单，库存调整单 */
  operationNo = "";

  /** 出库行明细 */
  outSkuRowDetailDtoList = [];

  /** 平台履行时间-报损 */
  platformFulfilmentTime = "";

  /** 是否已推送ebs 0:否 1：是 */
  pushEbsFlag = undefined;

  /** 出库明细 */
  skuDetailDtoList = [];

  /** 源OMS销售订单编号 */
  soOrderNo = "";

  /** 来源子类型 */
  sourceChildType = undefined;

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 */
  sourceType = undefined;

  /** 来源子库编码 */
  sourceWarehouseCode = "";

  /** 供应商编号 */
  supplierCode = "";

  /** 目标子库编码 */
  targetWarehouseCode = "";

  /** TMS操作类型 10:出库 20:调拨 30:盘点 40:报损 */
  tmsOperationType = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 事务id */
  transactionNo = "";

  /** 事务处理来源 */
  transactionSourceCode = undefined;

  /** 单据类型 */
  type = "";

  /** 更新人 */
  updateBy = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class HistoryFulfilmentInRequestDto {
  /** 是否散货 */
  bulkCargoFlag = false;

  /** 入库上架明细 */
  inPutPoDetailDtoList = [];

  /** 来源单号 */
  sourceNo = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class IPage {
  /** current */
  current = undefined;

  /** hitCount */
  hitCount = false;

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** searchCount */
  searchCount = false;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class InDeliverySendBackCountRequestParamsDto {
  /** 采购单号 */
  pono = "";

  /** 行号 */
  rowNo = [];

  /** sku */
  skuNoList = [];

  /** 仓库编号 */
  warehouseCode = "";
}

class InDeliverySendBackCountResponseRpcDto {
  /** 采购单号 */
  pono = "";

  /** 可退数量 */
  refundableQty = undefined;

  /** 行号 */
  rowNo = undefined;

  /** sku编号 */
  skuNo = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class InDeliverySendBackRequestParamsDto {
  /** 退货箱编号 */
  boxNoList = [];

  /** 采购单号 */
  pono = "";

  /** 退货数量 */
  refundQty = undefined;

  /** 行号 */
  rowNo = undefined;

  /** 采购单号 */
  skuNo = "";

  /** 仓库编号 */
  warehouseCode = "";
}

class InDeliverySkuLineBoxRequestParamsDto {
  /** 箱号 */
  boxNo = "";

  /** 箱高 */
  height = undefined;

  /** 装箱明细 */
  inDetailPDAReceivingRequestDtos = [];

  /** 入库单 */
  iono = "";

  /** 箱长 */
  length = undefined;

  /** MPQ数量 */
  mpq = undefined;

  /** 来源单号 */
  sourceNo = "";

  /** 箱宽 */
  width = undefined;
}

class InDeliverySkuLineRequestParamsDto {
  /** 子交货单号（交货单单据LNNO） */
  deliveryNo = "";

  /** 计划交货数量 */
  planDeliveryQty = undefined;

  /** 采购单号 */
  pono = "";

  /** 采购价 */
  purchasePrice = undefined;

  /** 行序号 */
  rowNo = undefined;

  /** sku编号 */
  skuNo = "";

  /** 排序权重 */
  sort = undefined;
}

class InDeliveryWriteBackDto {
  /** sku拣货信息 */
  inDeliveryWriteBackLineDtoList = [];

  /** 入库单号 */
  iono = "";

  /** 来源子类型 */
  sourceChildType = undefined;

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 */
  sourceType = "IN_FACTORY_DIRECT";

  /** 来源类型 */
  type = undefined;

  /** 箱信息 */
  wareHouseBoxRequestParamDtoList = [];

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class InDeliveryWriteBackLineDto {
  /** 批次号 */
  batchNo = "";

  /** sku总数量 */
  inQty = undefined;

  /** 库位 */
  positionCode = "";

  /** sku编号 */
  skuNo = "";
}

class InDetailCreateRequestDto {
  /** 箱数 */
  boxNum = undefined;

  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** MPQ */
  mpq = undefined;

  /** 计划入库数 */
  planQty = undefined;

  /** 产品编号 */
  productCode = "";

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 余数 */
  remainderQty = undefined;

  /** sku */
  sku = "";

  /** 供应商变体规格 json */
  supplierVariant = "";

  /** 变体规格 json */
  variant = "";
}

class InDetailPDAReceivingFulRequestDto {
  /** fn_sku */
  fnSku = "";

  /** 实收数量/装箱数量 */
  qty = undefined;

  /** sku */
  sku = "";
}

class InPlanAllocationEditRequestDto {
  /** 调拨单号 */
  adno = "";

  /** 目的仓库编号 */
  targetWarehouse = "";
}

class InPlanCreateRequestParamsDto {
  /** 是否历史订单，0-否，1-是 */
  historyOrderFlag = undefined;

  /** 入库计划-明细 */
  inPlanDetailCreateRequestParamsDtoList = [];

  /** 入库单号 */
  iono = "";

  /** 订单子类型 */
  orderChildType = undefined;

  /** 平台编号 */
  platformCode = "";

  /** 参考单号 */
  referenceNo = "";

  /** 备注 */
  remark = "";

  /** 来源子类型 1:采购入库 2:FBA调拨 3:WFS调拨 4:三方调拨 5:自营调拨 6:搬仓调拨 7:WFS调拨 8:调拨物流退件 9:销售物流退件 10:销售退货 */
  sourceChildType = undefined;

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 20:退货单 30:交货单 50:调拨单 90:公司间交易 */
  sourceType = undefined;

  /** 状态 10:待入库 20:部分入库 30:已入库 40：强制完结 */
  status = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class InPlanDetailCreateRequestParamsDto {
  /** 实际入库数 */
  realQty = undefined;

  /** sku */
  skuNo = "";
}

class InPlanDetailOneClickInboundDto {
  /** 产品名称 */
  productName = "";

  /** 实收数量 */
  realQty = undefined;

  /** sku编号 */
  skuNo = "";
}

class InPlanDetailResponseDto {
  /** id */
  id = undefined;

  /** 明细list */
  inPlanDetailList = [];

  /** 入库计划单号 */
  ipno = "";

  /** 计划入库数 */
  planQty = undefined;

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 实际入库数 */
  realQty = undefined;

  /** sku */
  skuNo = "";

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 20:退货单 30:交货单 50:调拨单 90:公司间交易 */
  sourceType = undefined;

  /** 单价 */
  unitPrice = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class InPlanDetailResponseRpcDto {
  /** 入库计划单号 */
  ipno = "";

  /** 计划入库数 */
  planQty = undefined;

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 实际入库数 */
  realQty = undefined;

  /** sku */
  skuNo = "";

  /** 单价 */
  unitPrice = undefined;
}

class InPlanMasterDetailResponseDto {
  /** 入库时间 */
  deliveryTime = "";

  /** 主键 */
  id = undefined;

  /** 明细list */
  inPlanDetailList = [];

  /** 入库计划单号 */
  ipno = "";

  /** 来源子类型 1:采购入库 2:FBA调拨 3:WFS调拨 4:三方调拨 5:自营调拨 6:搬仓调拨 7:WFS调拨 8:调拨物流退件 9:销售物流退件 10:销售退货 */
  sourceChildType = undefined;

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 20:退货单 30:交货单 50:调拨单 90:公司间交易 */
  sourceType = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class InPlanMasterInfoResponseRpcDto {
  /** 入库计划单状态 10:待入库 20:部分入库 30:已入库 */
  inPlanStatus = undefined;

  /** 入库单状态 5:待发货 10:未签收 20:已签收 30:已收货 40:已质检 50:已称重 60:部分上架 70:已上架 80:入库失败 90:已取消 */
  inStatus = undefined;

  /** 来源单号 */
  sourceNo = "";
}

class InPlanMasterOneClickInboundDto {
  /** 入库sku信息 */
  inPlanDetailDtoList = [];

  /** 入库计划单 */
  ipno = "";

  /** 是页面请求标识 */
  isPageRequestFlag = false;

  /** 平台履行时间 */
  platformFulfilmentTime = "";

  /** 库位 */
  positionCode = "";
}

class InPlanMasterRequestDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 >1:是 */
  deleted = undefined;

  /** 是否历史订单，0-否，1-是 */
  historyOrderFlag = undefined;

  /** 主键 */
  id = undefined;

  /** 入库单号 */
  iono = "";

  /** 入库计划单号 */
  ipno = "";

  /** 版本号 */
  lockVersion = undefined;

  /** 订单子类型 */
  orderChildType = undefined;

  /** 平台编号 */
  platformCode = "";

  /** 参考单号 */
  referenceNo = "";

  /** 备注 */
  remark = "";

  /** 来源子类型 1:采购入库 2:FBA调拨 3:WFS调拨 4:三方调拨 5:自营调拨 6:搬仓调拨 7:WFS调拨 8:调拨物流退件 9:销售物流退件 10:销售退货 */
  sourceChildType = undefined;

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 20:退货单 30:交货单 50:调拨单 90:公司间交易 */
  sourceType = undefined;

  /** 状态 10:待入库 20:部分入库 30:已入库 */
  status = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class InPlanMasterResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 主键 */
  id = undefined;

  /** 入库单号 */
  iono = "";

  /** 入库计划单号 */
  ipno = "";

  /** 订单子类型 */
  orderChildType = undefined;

  /** 参考单号 */
  referenceNo = "";

  /** 来源子类型 1:采购入库 2:FBA调拨 3:WFS调拨 4:三方调拨 5:自营调拨 6:搬仓调拨 7:WFS调拨 8:调拨物流退件 9:销售物流退件 10:销售退货 */
  sourceChildType = undefined;

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 20:退货单 30:交货单 50:调拨单 90:公司间交易 */
  sourceType = undefined;

  /** 状态 10:待入库 20:部分入库 30:已入库 */
  status = undefined;

  /** 供应商编号，采购入库必传 */
  supplierCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 仓库类型 */
  warehouseType = undefined;

  /** 运单号 */
  waybillNo = "";
}

class InPlanMasterResponseRpcDto {
  /** 是否历史订单，0-否，1-是 */
  historyOrderFlag = undefined;

  /** 入库计划单明细列表 */
  inPlanDetailResponseRpcDto = [];

  /** 入库计划单号 */
  ipno = "";

  /** 订单子类型 */
  orderChildType = undefined;

  /** 备注 */
  remark = "";

  /** 来源子类型 */
  sourceChildType = undefined;

  /** 状态 */
  status = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class InPlanOmsCreateRequestDto {
  /** 渠道编号 */
  channelCode = "";

  /** 数据类型 数据类型 1:url 2:base64 */
  contentType = undefined;

  /** 预计到货时间 */
  estimateTime = "";

  /** 文件后缀 */
  fileType = "";

  /** 是否历史订单 默认false，不是历史订单不需要传该参数，是则传ture */
  historyOrder = false;

  /** 手工单：true，逆向物流：false */
  manualFlag = false;

  /** 包裹明细 */
  omsPackageInfoDtoList = [];

  /** 平台编号 */
  platformCode = "";

  /** 渠道商编号 */
  providerCode = "";

  /** 参考单号（退货单号等） */
  referenceNo = "";

  /** 备注 */
  remark = "";

  /** 店铺编号 */
  shopCode = "";

  /** 入库SKU明细 */
  skuList = [];

  /** 订单编号 */
  soOrderNo = "";

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 */
  sourceType = undefined;

  /** 是否含税 0:否1:是 */
  taxFlag = undefined;

  /** 跟踪号 */
  trackingNo = "";

  /** 跟踪号 */
  trackingNumber = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 面单数据 */
  uri = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 运单号 */
  waybillNo = "";
}

class InPlanResponseDto {
  /** 入库时间 */
  deliveryTime = "";

  /** 主键 */
  id = undefined;

  /** 明细list */
  inPlanDetailList = [];

  /** 入库计划单号 */
  ipno = "";

  /** 来源子类型 1:采购入库 2:FBA调拨 3:WFS调拨 4:三方调拨 5:自营调拨 6:搬仓调拨 7:WFS调拨 8:调拨物流退件 9:销售物流退件 10:销售退货 */
  sourceChildType = undefined;

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 20:退货单 30:交货单 50:调拨单 90:公司间交易 */
  sourceType = undefined;

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class InPlanResponseRpcDto {
  /** 入库计划单号 */
  ipno = "";

  /** 来源单号 */
  sourceNo = "";
}

class InPlanStatusRequestDto {
  /** 来源单号 */
  inPlanStatusEnum = "Cancel";

  /** 来源单号 */
  sourceNo = "";
}

class InPlanUpdateRequestDto {
  /** 来源单号 */
  sourceNo = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class InPutBoxDetailDto {
  /** 箱号 */
  boxNo = "";

  /** 箱高 */
  height = undefined;

  /** 箱入库数量 */
  inQty = undefined;

  /** 箱长 */
  length = undefined;

  /** MPQ，每箱数量 */
  mpq = undefined;

  /** 箱宽 */
  width = undefined;
}

class InPutDetailDto {
  /** 批次号 */
  batchNo = "";

  /** 入库单该sku所有的箱信息 */
  inPutBoxDetailDtoList = [];

  /** sku入库总数量 */
  inTotalQty = undefined;

  /** sku编号 */
  skuNo = "";
}

class InPutPoDetailDto {
  /** 批次号 */
  batchNo = "";

  /** 入库单该sku所有的箱信息 */
  inPutBoxDetailDtoList = [];

  /** sku入库总数量 */
  inTotalQty = undefined;

  /** sku编号 */
  skuNo = "";
}

class InoutFulfilmentResponseRpcDto {
  /** 出库单号 */
  dono = "";

  /** 入库计划单主数据 */
  inPlanMasterResponseRpcDto = new InPlanMasterResponseRpcDto();

  /** 入库单号 */
  iono = "";

  /** 入库计划单号 */
  ipno = "";

  /** 出库计划单号 */
  opno = "";

  /** 出库计划单主数据 */
  outPlanMasterResponseRpcDto = new OutPlanMasterResponseRpcDto();

  /** 平台编号 */
  platformCode = "";

  /** 店铺编号 */
  shopCode = "";

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 */
  sourceType = undefined;
}

class InventoryCostPushToEbsRequestDto {
  /** 头信息 */
  p_page_info = new P_PAGE_INFO();

  /** 主体信息 */
  p_query_info = new P_QUERY_INFO();
}

class InventoryCostRequestDto {
  /** sku列表 */
  skuNoList = [];

  /** 仓库编号 */
  warehouseCode = "";
}

class LendDetailResponseDto {
  /** 军团名称 */
  corpsName = "";

  /** 领用数量 */
  lendQty = undefined;

  /** 领用单号 */
  lyno = "";

  /** 一级品类 */
  primaryProductLine = "";

  /** 产品标题 */
  productTitle = "";

  /** sku编号 */
  skuNo = "";

  /** 库存成本(数量*单个库存成本) */
  storageCost = undefined;
}

class LendMasterDetailResponseDto {
  /** 领用地址 */
  address = "";

  /** 首要原因 */
  firstReason = "";

  /** 主键 */
  id = undefined;

  /** 工作流实例id */
  instanceId = "";

  /** 领用单号 */
  lyno = "";

  /** 联系电话 */
  mobile = "";

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 领用原因 */
  reason = "";

  /** 领用人 */
  recipients = "";

  /** 备注 */
  remark = "";

  /** 次要原因 */
  secondReason = "";

  /** sku明细 */
  skuList = [];

  /** 状态 10:未审核 20:审核通过 30:已拣货 40:已发运 50:已驳回 60: 审核中 */
  status = undefined;

  /** 总金额 */
  totalAmount = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 具体用途 */
  useReason = "";

  /** 来源仓库编号 */
  warehouseCode = "";

  /** 来源仓库名称 */
  warehouseName = "";
}

class LendMasterPageResponseDto {
  /** 领用地址 */
  address = "";

  /** 审核时间 */
  approvalTime = "";

  /** 军团名称 */
  corpsName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 审核人 */
  currentApproval = "";

  /** 首要原因 */
  firstReason = "";

  /** 主键 */
  id = undefined;

  /** 工作流实例id */
  instanceId = "";

  /** 领用单号 */
  lyno = "";

  /** 联系电话 */
  mobile = "";

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 数量 */
  quantity = undefined;

  /** 领用人 */
  recipients = "";

  /** 领用人部门 */
  recipientsDepartment = "";

  /** 备注 */
  remark = "";

  /** 次要原因 */
  secondReason = "";

  /** sku */
  skuNo = "";

  /** 状态 10:未审核 20:审核通过 30:已拣货 40:已发运 50:已驳回 60: 审核中 */
  status = undefined;

  /** 具体用途 */
  useReason = "";

  /** 来源仓库编号 */
  warehouseCode = "";

  /** 来源仓库名称 */
  warehouseName = "";
}

class LendMasterRequestDto {
  /** 领用地址 */
  address = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 >1:是 */
  deleted = undefined;

  /** 主键 */
  id = undefined;

  /** 工作流实例id */
  instanceId = "";

  /** 领用单号 */
  lyno = "";

  /** 联系电话 */
  mobile = "";

  /** 平台编号 */
  platformCode = "";

  /** 领用原因 */
  reason = "";

  /** 领用人 */
  recipients = "";

  /** 状态 10:未审核 20:审核通过 30:已拣货 40:已发运 50:已驳回 60: 审核中 */
  status = undefined;

  /** 成本总价 */
  totalStorageCost = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 具体用途 */
  useReason = "";

  /** 来源仓库编号 */
  warehouseCode = "";

  /** 来源仓库名称 */
  warehouseName = "";
}

class LogisticsReturnCreateInDto {
  /** sku明细 */
  returnDetailRequestDtos = [];

  /** 退件记录号 */
  returnNo = "";
}

class LogisticsReturnRecordRequestDto {
  /** 产品名称 */
  productName = "";

  /** 出库数量 */
  qty = undefined;

  /** 退件记录号 */
  returnNo = "";

  /** 已退货数量 */
  returnQty = undefined;

  /** sku */
  skuNo = "";
}

class LogisticsReturnRecordResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 处理结果 10:入库 20:报损 30:重发 */
  handleResult = undefined;

  /** id */
  id = undefined;

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 出库计划单号 */
  opno = "";

  /** 备注 */
  remark = "";

  /** 退件原因详情 */
  returnDetail = "";

  /** 退件记录号 */
  returnNo = "";

  /** 退件原因 */
  returnReason = "";

  /** 退件签收时间 */
  signTime = "";

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 10:销售订单 20:调拨单 */
  sourceType = undefined;

  /** 状态 10:退件签收 20:部分入库 30:全部入库 */
  status = undefined;

  /** 来源单号 */
  trackingNo = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class LogisticsReturnRecordResponseRpcDto {
  /** 出库计划单号 */
  opno = "";

  /** 退件记录号 */
  returnNo = "";

  /** 来源单号 */
  sourceNo = "";
}

class LogisticsReverseLabelRequestDto {
  /** sku明细 */
  detailRequestDtos = [];

  /** 发件人地址1 */
  fromAddress1 = "";

  /** 发件人地址2 */
  fromAddress2 = "";

  /** 发件人城市 */
  fromCity = "";

  /** 发件人国家 */
  fromCounty = "";

  /** 发件人国家简称 */
  fromCountyCode = "";

  /** 发件人姓名 */
  fromName = "";

  /** 发件人电话号码 */
  fromPhone = "";

  /** 发件人邮编 */
  fromPostCode = "";

  /** 发件人州 */
  fromProvince = "";

  /** 发件人州简称 */
  fromProvinceCode = "";

  /** 标签备注 */
  labelRemark = "";

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 包裹明细 */
  omsPackageInfoDtos = [];

  /** 销售订单号 */
  orderNo = "";

  /** 平台编号 */
  platformCode = "";

  /** 退货单号(平台订单号) */
  returnOrderId = "";

  /** 店铺编号 */
  shopCode = "";

  /** 订单编号 */
  soOrderNo = "";

  /** 收件人地址1 */
  toAddress1 = "";

  /** 收件人地址2 */
  toAddress2 = "";

  /** 收件人城市 */
  toCity = "";

  /** 收件人国家 */
  toCounty = "";

  /** 收件人国家简称 */
  toCountyCode = "";

  /** 收件人姓名 */
  toName = "";

  /** 收件人电话号码 */
  toPhone = "";

  /** 收件人邮编 */
  toPostCode = "";

  /** 收件人州 */
  toProvince = "";

  /** 收件人州简称 */
  toProvinceCode = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 退货仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class LogisticsReverseLabelResponseDto {
  /** 数据类型 1:url 2:base64 */
  contentType = undefined;

  /** 文件类型 */
  fileType = "";

  /** 发件人地址1 */
  fromAddress1 = "";

  /** 发件人地址2 */
  fromAddress2 = "";

  /** 发件人城市 */
  fromCity = "";

  /** 发件人国家 */
  fromCounty = "";

  /** 发件人国家简称 */
  fromCountyCode = "";

  /** 发件人姓名 */
  fromName = "";

  /** 发件人电话号码 */
  fromPhone = "";

  /** 发件人邮编 */
  fromPostCode = "";

  /** 发件人州 */
  fromProvince = "";

  /** 发件人州简称 */
  fromProvinceCode = "";

  /** 标签备注 */
  labelRemark = "";

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 销售订单号 */
  orderNo = "";

  /** 包裹信息 */
  packageInfo = "";

  /** 文件路径 */
  path = "";

  /** 是否已生成逆向物流单: 0:否 1:是 */
  reverseFlag = false;

  /** 状态: 0:初始化 10:未处理 20:已处理 30:处理失败 */
  status = undefined;

  /** 收件人地址1 */
  toAddress1 = "";

  /** 收件人地址2 */
  toAddress2 = "";

  /** 收件人城市 */
  toCity = "";

  /** 收件人国家 */
  toCounty = "";

  /** 收件人国家简称 */
  toCountyCode = "";

  /** 收件人姓名 */
  toName = "";

  /** 收件人电话号码 */
  toPhone = "";

  /** 收件人邮编 */
  toPostCode = "";

  /** 收件人州 */
  toProvince = "";

  /** 收件人州简称 */
  toProvinceCode = "";

  /** 最终跟踪号 */
  trackingNo = "";

  /** 退货仓库 */
  warehouse = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 运单号 */
  waybillNo = "";
}

class OmsPackageInfoDetailDto {
  /** 数量 */
  qty = undefined;

  /** 实收数量 */
  realQty = undefined;

  /** sku编号 */
  skuNo = "";
}

class OmsPackageInfoDto {
  /** 创建时间 */
  createTime = "";

  /** 包裹明细 */
  omsPackageInfoDetailDtos = [];

  /** 包裹单号 */
  packageNo = "";

  /** 平台编号 */
  platformCode = "";

  /** 退货单号 */
  returnOrderId = "";
}

class OrderApplyOperationRequestDto {
  /** 来源单号 */
  sourceNo = "";
}

class OrderCreateRequestDto {
  /** 是否申请多渠道 默认false，如果是多渠道订单则传ture */
  applyMcfFlag = false;

  /** 创建人 */
  createBy = "";

  /** 币种 */
  currency = "";

  /** 报关标识：0:否 1:是 */
  customsDeclarationFlag = undefined;

  /** 是否直接发货，默认ture，如果需要等待发货指令再发货传false */
  directShipFlag = false;

  /** 换货标识 1正常 2换货 */
  exchangeGoodsFlag = undefined;

  /** 是否历史订单 默认false，不是历史订单不需要传该参数，是则传ture */
  historyOrder = false;

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 是否多渠道订单 FBA订单才传，ture表示该FBA订单之前是申请多渠道产生的 */
  mcfFlag = false;

  /** 订单明细 */
  orderDetailRequestDtoList = [];

  /** 订单号 */
  orderNo = "";

  /** 订单类型，1-平台订单,2-企业订单 */
  orderType = undefined;

  /** 原订单号 */
  originalOrderNo = "";

  /** 原系统订单类型 1正常 2补发 3重发 4测评 5改发 */
  originalSystemOrderType = undefined;

  /** 平台编号 */
  platformCode = "";

  /** 平台订单号 */
  platformOrderId = "";

  /** 平台店铺编号 */
  platformShopNo = "";

  /** 下单时间 */
  purchaseDate = "";

  /** 备注 */
  remark = "";

  /** 销售价格 */
  salePrice = undefined;

  /** 配送方式，1-平台配送,2-卖家自配送 */
  shipmentMethod = undefined;

  /** 发运地址信息 */
  shippedAddressDto = new ShippedAddressDto();

  /** 是否需要发运 默认ture，正常订单默认ture表示需要发运扣库存；历史订单<包括WFS，FNA平台的订单，这些订单正常都是需要扣库存的>需要扣库存传ture，不需要传false */
  shippedFlag = false;

  /** 店铺编号 */
  shopCode = "";

  /** 店铺名称 */
  shopName = "";

  /** 来源单号（包裹单号） */
  sourceNo = "";

  /** 系统订单类型 1正常 2补发 3重发 4测评 5改发 */
  systemOrderType = undefined;

  /** 总税额 */
  totalTaxPrice = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 包裹交易号 */
  transactionId = "";

  /** 唯一订单编号 */
  uniqueOrderNo = "";

  /** 仓库编号 */
  warehouseCode = "";
}

class OrderDetailRequestDto {
  /** 明细换货标识 1正常 2换货 */
  exchangeGoodsItemFlag = undefined;

  /** 订单物品明细ID */
  itemId = "";

  /** mskuNo */
  mskuNo = "";

  /** 单价 */
  price = undefined;

  /** 产品编号 */
  productCode = "";

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** SKU数量 */
  qty = undefined;

  /** sku */
  skuNo = "";

  /** 含税金额（sku含税单价*数量） */
  taxIncludedAmount = undefined;

  /** 税额（sku税额*数量） */
  taxPrice = undefined;

  /** 包裹交易号 */
  transactionId = "";
}

class OrderUpdateChannelRequestDto {
  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 来源单号 */
  sourceNo = "";
}

class OutDetailCreateRequestDto {
  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 出库数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 行明细 */
  skuPoLineDetails = [];
}

class OutInterceptBeforeInfoResponseDto {
  /** 是否可拦截: 1是 0否 */
  isSuccess = undefined;

  /** 来源单号(包裹号) */
  sourceNo = "";
}

class OutPickBoxDetailDto {
  /** 箱号 */
  boxNo = "";

  /** 箱出库数量 */
  outQty = undefined;

  /** 拆箱标识：0:否1:是 */
  unpackFlag = undefined;
}

class OutPickDetailDto {
  /** 批次号 */
  batchNo = "";

  /** 出库箱信息 */
  outPickBoxDetailDtoList = [];

  /** sku出库总数量 */
  outTotalQty = undefined;

  /** sku编号 */
  skuNo = "";
}

class OutPlanCreateRequestParamsDto {
  /** 出库单号 */
  dono = "";

  /** 出库计划-明细 */
  outPlanDetailCreateRequestParamsDtoList = [];

  /** 平台编号 */
  platformCode = "";

  /** 备注 */
  remark = "";

  /** 店铺编号 */
  shopCode = "";

  /** 来源子类型 1:自配送订单 2:委托单 3:FBA订单 4:WFS订单 5:多渠道订单 6:FBA调拨 7:WFS调拨 8:三方调拨 9:自营调拨 10:搬仓调拨 11:采购退货 */
  sourceChildType = undefined;

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 10:销售订单 40:采购退货 50:调拨单 90:公司间交易 */
  sourceType = undefined;

  /** 状态 0:待匹配 10:缺货 20:匹配失败 25:齐货 26:部分齐货 26:待集货 30:待物流申请 40:申请失败 50:已推送 60:已发运 70:异常作废 */
  status = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class OutPlanDetailCreateRequestParamsDto {
  /** 订单物品明细ID */
  itemId = "";

  /** 计划出库数量 */
  planQty = undefined;

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** sku编号 */
  skuNo = "";

  /** 交易号 */
  transactionId = "";

  /** 单价 */
  unitPrice = undefined;
}

class OutPlanDetailFulfilmentRequestParamsDto {
  /** 实际出库数 */
  realQty = undefined;

  /** sku编号 */
  skuNo = "";
}

class OutPlanDetailPurchaseDto {
  /** 批次号 */
  batchNo = "";

  /** 箱号 */
  boxNo = "";

  /** 采购单号 */
  pono = "";

  /** 实际出库数 */
  qty = undefined;

  /** 行号 */
  rowNo = undefined;

  /** sku编号 */
  skuNo = "";

  /** 供应商id */
  supplierName = "";
}

class OutPlanDetailResponseDto {
  /** 地址 */
  address = "";

  /** 地址2 */
  address2 = "";

  /** 城市 */
  city = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 客户公司名称 */
  customerName = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 出库时间 */
  deliveryTime = "";

  /** 区县 */
  district = "";

  /** 邮箱地址 */
  email = "";

  /** 门牌号 */
  houseNumber = "";

  /** id */
  id = undefined;

  /** 订单物品明细ID */
  itemId = "";

  /** 版本号 */
  lockVersion = undefined;

  /** 物流状态 0:初始化 10:未处理 20:已处理 */
  logisticStatus = undefined;

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 物流面单文件路径 */
  logisticsLabelPath = "";

  /** 运费 */
  logisticsPrice = undefined;

  /** 物流渠道商编号/发货物流 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 移动电话 */
  mobilePhone = "";

  /** 出库计划单号 */
  opno = "";

  /** SO单号/订单号 */
  orderNo = "";

  /** 出库计划单明细 */
  outplanDetail = [];

  /** 计划出库数量 */
  planQty = undefined;

  /** 平台编号 */
  platformCode = "";

  /** 平台 */
  platformName = "";

  /** 邮编 */
  postcode = "";

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 省份 */
  province = "";

  /** 省份编号 */
  provinceCode = "";

  /** 下单时间 */
  purchaseDate = "";

  /** 实际出库数 */
  realQty = undefined;

  /** 收件人 */
  recipient = "";

  /** 备注 */
  remark = "";

  /** 销售价格 */
  salePrice = undefined;

  /** 店铺编号 */
  shopCode = "";

  /** 店铺 */
  shopName = "";

  /** sku编号 */
  skuNo = "";

  /** 来源子类型 1:自配送订单 2:委托单 3:FBA订单 4:WFS订单 5:多渠道订单 6:FBA调拨 7:WFS调拨 8:三方调拨 9:自营调拨 10:搬仓调拨 11:采购退货 */
  sourceChildType = undefined;

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型/计划单类型   10:销售订单 40:采购退货 50:调拨单 90:公司间交易 */
  sourceType = undefined;

  /** 状态 0:待匹配 10:缺货 20:匹配失败 25:齐货 26:部分齐货 26:待集货 30:待物流申请 40:申请失败 50:已推送 60:已发运 70:异常作废 */
  status = undefined;

  /** 收件人纳税号 */
  taxid = "";

  /** 固定电话 */
  telephone = "";

  /** 最终跟踪号 */
  trackingNo = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 交易号 */
  transactionId = "";

  /** 单价 */
  unitPrice = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号/发货仓库 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 运单号 */
  waybillNo = "";

  /** 出库重量 */
  weight = undefined;
}

class OutPlanDetailResponseRpcDto {
  /** 订单物品明细ID */
  itemId = "";

  /** 出库计划单号 */
  opno = "";

  /** 计划出库数量 */
  planQty = undefined;

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 实际出库数 */
  realQty = undefined;

  /** sku编号 */
  skuNo = "";

  /** 交易号 */
  transactionId = "";

  /** 单价 */
  unitPrice = undefined;
}

class OutPlanFulfilmentRequestParamsDto {
  /** 出库单号 */
  dono = "";

  /** sku拣货信息 */
  inDeliveryWriteBackLineDtoList = [];

  /** 出库计划-明细 */
  outPlanDetailFulfilmentRequestParamsDtoList = [];

  /** 来源类型 */
  outSourceChildType = undefined;

  /** 备注 */
  remark = "";

  /** 来源单号 */
  sourceNo = "";

  /** 状态 0:待匹配 10:缺货 20:匹配失败 25:齐货 26:部分齐货 26:待集货 30:待物流申请 40:申请失败 50:已推送 60:已发运 70:异常作废 */
  status = undefined;

  /** 平台编号 */
  targetPlatformCode = "";

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 调入交易主体编号 */
  tradeCompanyInCode = "";

  /** 调入交易主体名称 */
  tradeCompanyInName = "";

  /** 箱信息 */
  wareHouseBoxRequestParamDtoList = [];
}

class OutPlanMasterCreateRequestRpcDto {
  /** 出库单明细 */
  detailCreateRequestDtos = [];

  /** 出库单号 */
  dono = "";

  /** 来源子类型 1:自配送订单 2:委托单 3:FBA订单 4:WFS订单 5:多渠道订单 6:FBA调拨 7:WFS调拨 8:三方调拨 9:自营调拨 10:搬仓调拨 11:采购退货 */
  sourceChildType = undefined;

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 13:销售订单 14:采购退货单 15:调拨单 16:借调单 17:SP销售单 18:委托单 19:多渠道订单 */
  sourceType = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class OutPlanMasterRequestParamsDto {
  /** 出库单号 */
  doNo = "";

  /** 出库单列表 */
  doNoIn = [];

  /** 创建时间结束时间 */
  endTime = "";

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道商编号 */
  logisticsProviderCode = "";

  /** 出库计划单号 */
  opno = "";

  /** 平台编号 */
  platformCode = "";

  /** 平台单号 */
  platformOrderId = "";

  /** 省份编号 */
  provinceCode = "";

  /** 参考单号（销售类型为SO订单号） */
  referenceNo = "";

  /** 店铺编号 */
  shopCode = "";

  /** sku编号 */
  skuNo = "";

  /** 来源子类型 1:自配送订单 2:委托单 3:FBA订单 4:WFS订单 5:多渠道订单 6:FBA调拨 7:WFS调拨 8:三方调拨 9:自营调拨 10:搬仓调拨 11:采购退货 */
  sourceChildType = undefined;

  /** 来源单号 */
  sourceNo = "";

  /** 来源单号列表 */
  sourceNoIn = [];

  /** 来源类型 10:销售订单 40:采购退货 50:调拨单 */
  sourceType = undefined;

  /** 创建时间开始时间 */
  startTime = "";

  /** 状态 0:待匹配 10:缺货 20:匹配失败 25:齐货 26:部分齐货 26:待集货 30:待物流申请 40:申请失败 50:已推送 60:已发运 70:异常作废 */
  status = [];

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 运单号 */
  waybillNo = "";
}

class OutPlanMasterResponseDetailDto {
  /** 地址 */
  address = "";

  /** 地址2 */
  address2 = "";

  /** 城市 */
  city = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 客户公司名称 */
  customerName = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 出库时间 */
  deliveryTime = "";

  /** 区县 */
  district = "";

  /** 邮箱地址 */
  email = "";

  /** 门牌号 */
  houseNumber = "";

  /** 订单物品明细ID */
  itemId = "";

  /** 版本号 */
  lockVersion = undefined;

  /** 物流状态 0:初始化 10:未处理 20:已处理 */
  logisticStatus = undefined;

  /** 物流渠道服务编号 */
  logisticsChannelCode = "";

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 物流面单文件路径 */
  logisticsLabelPath = "";

  /** 运费 */
  logisticsPrice = undefined;

  /** 物流渠道商编号/发货物流 */
  logisticsProviderCode = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 移动电话 */
  mobilePhone = "";

  /** 多渠道订单号 */
  multiChannelOrder = "";

  /** 出库计划单号 */
  opno = "";

  /** SO单号/订单号 */
  orderNo = "";

  /** 出库计划单明细 */
  outplanDetail = [];

  /** 计划出库数量 */
  planQty = undefined;

  /** 平台编号 */
  platformCode = "";

  /** 平台 */
  platformName = "";

  /** 平台单号 */
  platformOrderId = "";

  /** 邮编 */
  postcode = "";

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 省份 */
  province = "";

  /** 省份编号 */
  provinceCode = "";

  /** 下单时间 */
  purchaseDate = "";

  /** 实际出库数 */
  realQty = undefined;

  /** 收件人 */
  recipient = "";

  /** 备注 */
  remark = "";

  /** 销售价格 */
  salePrice = undefined;

  /** 店铺编号 */
  shopCode = "";

  /** 店铺 */
  shopName = "";

  /** sku编号 */
  skuNo = "";

  /** 来源子类型 1:自配送订单 2:委托单 3:FBA订单 4:WFS订单 5:多渠道订单 6:FBA调拨 7:WFS调拨 8:三方调拨 9:自营调拨 10:搬仓调拨 11:采购退货 */
  sourceChildType = undefined;

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型/计划单类型   10:销售订单 40:采购退货 50:调拨单 90:公司间交易 */
  sourceType = undefined;

  /** 状态 0:待匹配 10:缺货 20:匹配失败 25:齐货 26:部分齐货 26:待集货 30:待物流申请 40:申请失败 50:已推送 60:已发运 70:异常作废 */
  status = undefined;

  /** 收件人纳税号 */
  taxid = "";

  /** 固定电话 */
  telephone = "";

  /** 最终跟踪号 */
  trackingNo = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 交易号 */
  transactionId = "";

  /** 单价 */
  unitPrice = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号/发货仓库 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 运单号 */
  waybillNo = "";

  /** 出库重量 */
  weight = undefined;
}

class OutPlanMasterResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 客户公司名称 */
  customerName = "";

  /** 出库时间 */
  deliveryTime = "";

  /** 出库单号 */
  doNo = "";

  /** 物流状态 0:初始化 10:未处理 20:已处理 30:已发运 40:已妥投 50：已取消 */
  logisticStatus = undefined;

  /** 物流渠道服务名称 */
  logisticsChannelName = "";

  /** 物流渠道商名称 */
  logisticsProviderName = "";

  /** 出库计划单号 */
  opno = "";

  /** 平台编号 */
  platformCode = "";

  /** 平台 */
  platformName = "";

  /** 平台单号 */
  platformOrderId = "";

  /** 参考单号（销售订单为SO订单号） */
  referenceNo = "";

  /** 备注 */
  remark = "";

  /** 店铺编号 */
  shopCode = "";

  /** 店铺 */
  shopName = "";

  /** 来源子类型 1:自配送订单 2:委托单 3:FBA订单 4:WFS订单 5:多渠道订单 6:FBA调拨 7:WFS调拨 8:三方调拨 9:自营调拨 10:搬仓调拨 11:采购退货 */
  sourceChildType = undefined;

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型/计划单类型   10:销售订单 40:采购退货 50:调拨单 90:公司间交易 */
  sourceType = undefined;

  /** 状态 0:待匹配 10:缺货 20:匹配失败 25:齐货 26:部分齐货 26:待集货 30:待物流申请 40:申请失败 50:已推送 60:已发运 70:异常作废 */
  status = undefined;

  /** 最终跟踪号 */
  trackingNo = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 子库编号 */
  warehouseCode = "";

  /** 子库名称 */
  warehouseName = "";

  /** 运单号 */
  waybillNo = "";
}

class OutPlanMasterResponseRpcDto {
  /** 出库时间 */
  deliveryTime = "";

  /** 出库单号 */
  dono = "";

  /** 出库计划单号 */
  opno = "";

  /** 出库计划单明细列表 */
  outPlanDetailResponseRpcDtoList = [];

  /** 备注 */
  remark = "";

  /** 来源子类型 */
  sourceChildType = undefined;

  /** 状态 */
  status = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class OutPlanPoOccupyResponseRpcDto {
  /** 调拨单号 */
  aono = "";

  /** 调拨单po占用数据 */
  poOccupyDetailList = [];

  /** 调拨单发运时间 */
  shipTime = "";

  /** 调拨单状态 */
  status = undefined;
}

class OutPlanSkuBatchCheckRequestDto {
  /** 批次退货详情 */
  outPlanSkuBatchDetailCheckDtoList = [];

  /** 退货单号 */
  reno = "";
}

class OutPlanSkuBatchDetailCheckDto {
  /** 批次号 */
  batchNo = "";

  /** 拣货数量 */
  qty = undefined;

  /** sku */
  skuNo = "";
}

class OutPlanUpdatePriceRequestDto {
  /** sku编号 */
  skuNo = "";

  /** 包裹单号 */
  sourceNo = "";

  /** 单价 */
  unitPrice = undefined;
}

class OutPlanUpdateStatusRequestDto {
  /** 修改原因信息 */
  message = "";

  /** 出库计划单号 */
  operationNo = "";

  /** 操作订单类型,入库计划单：1，出库计划单：2，库存调整单：3 */
  operationOrderType = undefined;

  /** 出库计划单状态 */
  status = undefined;
}

class OutReturnDetailRequestDto {
  /** 产品名称 */
  productName = "";

  /** 数量 */
  qty = undefined;

  /** sku编号 */
  skuNo = "";
}

class OutReturnSignRequestDto {
  /** 退件原因详情 */
  explain = "";

  /** 入库单号，WMS调用必传 */
  iono = "";

  /** 备注 */
  remark = "";

  /** 退件原因 */
  returnReason = "";

  /** 退件签收类型，7：调拨物流退件 8：自营销售物流退件 13：三方仓销售物流退件 */
  returnType = undefined;

  /** 来源单号，TMS调用必传 */
  sourceNo = "";

  /** 是否tms调用 */
  tmsFlag = false;

  /** 仓库Code */
  warehouseCode = "";

  /** 仓库Name */
  warehouseName = "";
}

class OutSkuRowDetailDto {
  /** 采购订单 */
  pono = "";

  /** 采购价 */
  purchasePrice = undefined;

  /** 采购员 */
  purchaser = "";

  /** 行号 */
  rowNo = undefined;

  /** sku编号 */
  skuNo = "";

  /** sku行出入库总数量 */
  totalQty = undefined;
}

class OutputParametersDTO {
  /** outputParameters */
  outputParameters = {};

  /** xresultRec */
  xresultRec = new XRESULTREC();

  /** xreturnBodyTb */
  xreturnBodyTb = new XRETURNBODYTB();
}

class P_PAGE_INFO {
  /** 页码 */
  pageId = "";

  /** 页容量 */
  pageSize = "";
}

class P_QUERY_INFO {
  /** 子库编码 */
  inventoryCode = "";

  /** queryItemInfoTbl */
  queryItemInfoTbl = new QUERY_ITEM_INFO_TBL();

  /** 行数量 */
  rowCount = "";

  /** 来源系统 */
  sourceSystem = "";
}

class PageInfo {
  /** endRow */
  endRow = undefined;

  /** hasNextPage */
  hasNextPage = false;

  /** hasPreviousPage */
  hasPreviousPage = false;

  /** isFirstPage */
  isFirstPage = false;

  /** isLastPage */
  isLastPage = false;

  /** list */
  list = [];

  /** navigateFirstPage */
  navigateFirstPage = undefined;

  /** navigateLastPage */
  navigateLastPage = undefined;

  /** navigatePages */
  navigatePages = undefined;

  /** navigatepageNums */
  navigatepageNums = [];

  /** nextPage */
  nextPage = undefined;

  /** pageNum */
  pageNum = undefined;

  /** pageSize */
  pageSize = undefined;

  /** pages */
  pages = undefined;

  /** prePage */
  prePage = undefined;

  /** size */
  size = undefined;

  /** startRow */
  startRow = undefined;

  /** total */
  total = undefined;
}

class PlatformAccountPeriodResponseDto {
  /** 账期 */
  accountPeriod = "";

  /** 是否关账 */
  closeFlag = false;

  /** 关账日期 */
  closeTime = "";

  /** 结束日期 */
  endDate = "";

  /** id */
  id = undefined;

  /** 开始日期 */
  startDate = "";
}

class PoOccupyDetail {
  /** 子交货单 */
  deliveryNo = "";

  /** 入库时间 */
  inTime = "";

  /** 不含税单价 */
  notTaxUnitPrice = undefined;

  /** 采购单号 */
  pono = "";

  /** 实际出库占用数 */
  qty = undefined;

  /** 行号 */
  rowNo = undefined;

  /** sku名称 */
  skuName = "";

  /** sku编号 */
  skuNo = "";

  /** 采购单位 */
  unit = "";
}

class PurchaseReturnCreateRequestDto {
  /** 地址 */
  address = "";

  /** 城市 */
  city = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 邮箱地址 */
  email = "";

  /** 移动电话 */
  mobilePhone = "";

  /** 邮编 */
  postcode = "";

  /** 省份 */
  province = "";

  /** 采购退货明细 */
  purchaseReturnDetailDtoList = [];

  /** 采购退货单号 */
  purchaseReturnNo = "";

  /** 收件人 */
  recipient = "";

  /** 备注 */
  remark = "";

  /** 固定电话 */
  telephone = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class PurchaseReturnDetailDto {
  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 采购退货行明细 */
  purchaseReturnLineDetailDtoList = [];

  /** sku退货总数量 */
  purchaseReturnTotalQty = undefined;

  /** sku编号 */
  skuNo = "";
}

class PurchaseReturnLineDetailDto {
  /** 箱号 */
  pono = "";

  /** 行序号 */
  rowNo = undefined;

  /** 采购行退货数量 */
  rowQty = undefined;
}

class PushRequestDto {
  /** 业务编号列表 */
  businessNoList = [];

  /** 单据类型 */
  flag = undefined;

  /** 单据类型 */
  operationOrderType = undefined;

  /** 是否重新收集数据 */
  recollectDataFlag = false;

  /** 推送接口 */
  thirdApi = "";
}

class QUERY_ITEM_INFO_TBL {
  /** queryItemInfoTblItem */
  queryItemInfoTblItem = [];
}

class QUERY_ITEM_INFO_TBL_ITEM {
  /** sku编码 */
  itemCode = "";
}

class RefundAbleQtyRequestParamsDto {
  /** 采购单号 */
  pono = "";

  /** sku */
  skuNo = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 仓库编号 */
  warehouseCode = "";
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new AmazonInventoryMonthlyCanCreateResponseDto();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ShippedAddressDto {
  /** 地址 */
  address = "";

  /** 地址2 */
  address2 = "";

  /** 城市 */
  city = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 客户公司名称 */
  customerName = "";

  /** 区县 */
  district = "";

  /** 邮箱地址 */
  email = "";

  /** 门牌号 */
  houseNumber = "";

  /** 移动电话 */
  mobilePhone = "";

  /** 邮编 */
  postcode = "";

  /** 省份 */
  province = "";

  /** 省份编号 */
  provinceCode = "";

  /** 收件人 */
  recipient = "";

  /** 发件人EORI */
  shipperEori = "";

  /** 发件人VAT */
  shipperVat = "";

  /** 收件人纳税号 */
  taxId = "";

  /** 固定电话 */
  telephone = "";
}

class SkuDetailDto {
  /** 价格 */
  price = undefined;

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** sku编号 */
  skuNo = "";

  /** sku出入库总数量 */
  totalQty = undefined;
}

class SkuPoLineDetail {
  /** 采购单号 */
  pono = "";

  /** 出库数量 */
  qty = undefined;

  /** 行号 */
  rowNo = undefined;
}

class SplitBoxRequestParamDto {
  /** 箱号 */
  box = "";

  /** 整箱拆分标识 */
  isAllStockFlag = false;

  /** 数量 */
  qty = undefined;

  /** 仓库编号 */
  warehouseCode = "";
}

class StockAdjustmentCreateImportDetailResponseDto {
  /** 单价 */
  price = undefined;

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 数量 */
  qty = undefined;

  /** sku */
  skuNo = "";

  /** 总金额 */
  totalMoney = undefined;
}

class StockAdjustmentCreateRequestDto {
  /** 调整时间 */
  adjustmentTime = "";

  /** 关联单据类型 */
  correlationType = undefined;

  /** 是否推送ebs 0:失败 1：成功 */
  isPushEbs = undefined;

  /** 平台编号 */
  platformCode = "";

  /** 货件编码 */
  shipmentId = "";

  /** 来源单号 */
  sourceNo = "";

  /** 状态 10:待调整 20:部分调整 30:已调整 40：已取消 */
  status = undefined;

  /** 库存调整单-主表 */
  stockAdjustmentMasterCreateRequestDtoList = [];

  /** 库存分配模式，1：指定平台；2：按订单分配 */
  stockMode = undefined;

  /** 供应商编号 */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StockAdjustmentDetailCreateRequestDto {
  /** 币种 */
  currency = "";

  /** 计划调整数 */
  planAdjustmentQty = undefined;

  /** 单价,金额 */
  price = undefined;

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** sku */
  skuNo = "";
}

class StockAdjustmentDetailDetailResponseDto {
  /** 库存调整单号 */
  adno = "";

  /** 币种 */
  currency = "";

  /** 集团货品单价 */
  groupGoodsPrice = undefined;

  /** id */
  id = undefined;

  /** 物流单价 */
  logisticsPrice = undefined;

  /** 非集团货品单价 */
  nonGroupGoodsPrice = undefined;

  /** 计划调整数 */
  planAdjustmentQty = undefined;

  /** 单价 */
  price = undefined;

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 实际调整数 */
  realAdjustmentQty = undefined;

  /** sku */
  skuNo = "";
}

class StockAdjustmentDetailHandleExceptionRequestDto {
  /** 集团货品单价 */
  groupGoodsPrice = undefined;

  /** id */
  id = undefined;

  /** 物流单价 */
  logisticsPrice = undefined;

  /** 非集团货品单价 */
  nonGroupGoodsPrice = undefined;
}

class StockAdjustmentDetailRequestDto {
  /** 创建人 */
  createBy = "";

  /** 币种 */
  currency = "";

  /** 计划调整数 */
  planAdjustmentQty = undefined;

  /** 单价 */
  price = undefined;

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** 实际调整数 */
  realAdjustmentQty = undefined;

  /** sku */
  skuNo = "";

  /** 库存成本 */
  storageCost = undefined;

  /** 总金额 */
  totalMoney = undefined;
}

class StockAdjustmentFulfilmentMasterRequestDto {
  /** 库存调整单号 */
  adno = "";

  /** sku batch 下的盘亏出库数量详情 */
  boxNoList = [];

  /** 关联单据类型 */
  correlationType = undefined;

  /** 履行标识 1：履行 0：取消 */
  fulfilmentFlag = undefined;

  /** 平台编号 */
  platformCode = "";

  /** 备注 */
  remark = "";

  /** 来源单号 */
  sourceNo = "";
}

class StockAdjustmentHandleExceptionRequestDto {
  /** 库存调整单号 */
  adno = "";

  /** 明细集合 */
  list = [];
}

class StockAdjustmentMasterCreateRequestDto {
  /** 操作订单类型 1 入库 2 出库 3冻结 */
  operationOrderType = undefined;

  /** 操作类型 领用出库  报损出库 具体见原型 */
  operationType = undefined;

  /** 备注 */
  remark = "";

  /** 库存调整单-明细 */
  stockAdjustmentDetailCreateRequestDtoList = [];
}

class StockAdjustmentMasterDetailResponseDto {
  /** 是否推送ebs 0：失败  1：成功 */
  isPushEbs = undefined;

  /** 单据类型 1 入库 2 出库 */
  operationOrderType = undefined;

  /** 操作类型      i. 领用出库
    ii. 报损出库：来源于WMS仓库报损需求/FBA库存动作
    iii. 盘亏出库：来源于WMS仓库盘点需求
    iv. 调拨入库差异盘亏出库：若接受报告发生扣减（负数）数量，则扣减部分生成出库计划单并扣减库存
    v. FBA移除货件出库：来源于FBA移除货件报告库存调整
    vi. 冻结
    vii. 盘盈入库
    viii. 调拨入库差异盘盈入库：调拨单根据接受报告履行入库，若接受报告数量大于计划入库输入，多出部分记录到此类型入库
    ix. 订单发货差异盘盈入库：FBA/WFS订单发货时库存不足，这针对不足部分做调整，增加至满足库存发货后重新履行发货。
    x. 移除货件入库
    xi. 报损入库：来源于FBA库存动作报告
    xii. 采购赠品入库
    xiii. 采购索赔入库 */
  operationType = undefined;

  /** 平台编号 */
  platformCode = "";

  /** 平台 */
  platformName = "";

  /** 原因 */
  reason = "";

  /** 备注 */
  remark = "";

  /** 来源单号 */
  sourceNo = "";

  /** 状态 10:待调整 20:部分调整 30:已调整 */
  status = undefined;

  /** 明细list */
  stockAdjustmentDetailResponseDtoList = [];

  /** 供应商编号 */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StockAdjustmentMasterListResponseDto {
  /** 调整时间 */
  adjustmentTime = "";

  /** 库存调整单号 */
  adno = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  curreny = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 主键 */
  id = undefined;

  /** 是否推送ebs 0：失败  1：成功 */
  isPushEbs = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 金额 */
  money = undefined;

  /** 单据类型 1 入库 2 出库 */
  operationOrderType = undefined;

  /** 操作类型      i. 领用出库
    ii. 报损出库：来源于WMS仓库报损需求/FBA库存动作
    iii. 盘亏出库：来源于WMS仓库盘点需求
    iv. 调拨入库差异盘亏出库：若接受报告发生扣减（负数）数量，则扣减部分生成出库计划单并扣减库存
    v. FBA移除货件出库：来源于FBA移除货件报告库存调整
    vi. 冻结
    vii. 盘盈入库
    viii. 调拨入库差异盘盈入库：调拨单根据接受报告履行入库，若接受报告数量大于计划入库输入，多出部分记录到此类型入库
    ix. 订单发货差异盘盈入库：FBA/WFS订单发货时库存不足，这针对不足部分做调整，增加至满足库存发货后重新履行发货。
    x. 移除货件入库
    xi. 报损入库：来源于FBA库存动作报告
    xii. 采购赠品入库
    xiii. 采购索赔入库 */
  operationType = undefined;

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 备注 */
  remark = "";

  /** 来源单号 */
  sourceNo = "";

  /** 状态 10:待调整 20:部分调整 30:已调整 40：已取消 */
  status = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StockAdjustmentMasterRequestParamsDto {
  /** 库存调整单号 */
  adno = "";

  /** id */
  id = undefined;

  /** 操作订单类型 1 入库 2 出库 */
  operationOrderType = undefined;

  /** 操作类型 */
  operationType = undefined;

  /** 平台编号 */
  platformCode = "";

  /** 平台 */
  platformName = "";

  /** 备注 */
  remark = "";

  /** sku列表 */
  skuList = [];

  /** 来源单号 */
  sourceNo = "";

  /** 供应商编号 */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StockSkuPlatformResponseDto {
  /** 军团名称 */
  corpsName = "";

  /** 锁定数量 */
  lockQty = undefined;

  /** 组织编号 */
  organizeCode = "";

  /** 组织名称 */
  organizeName = "";

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 产品名称 */
  productName = "";

  /** 母仓库编号 */
  rootWarehouseCode = "";

  /** 母仓库名称 */
  rootWarehouseName = "";

  /** 母仓库英文名称 */
  rootWarehouseNameEn = "";

  /** sku */
  sku = "";

  /** SPU编号 */
  spu = "";

  /** 在库数量 */
  stockQty = undefined;

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 在途数量 */
  transitQty = undefined;

  /** 可用数量 */
  useQty = undefined;

  /** 子库编号 */
  warehouseCode = "";

  /** 子库名称 */
  warehouseName = "";
}

class StorageDamageDetailResponseDto {
  /** 总金额 */
  amountCost = undefined;

  /** 军团 */
  crops = "";

  /** 库存成本(数量*单个sku价格)/货品总金额 */
  priceCost = undefined;

  /** 产品名称 */
  productName = "";

  /** 产品名称 */
  productTitle = "";

  /** 报损数量 */
  qty = undefined;

  /** sku编号 */
  skuNo = "";

  /** 库存成本(数量*单个库存成本)/报损金额 */
  storageCost = undefined;

  /** 仓库可用库存 */
  userableQty = undefined;
}

class StorageDamageMasterDetailResponseDto {
  /** 报损申请附件 */
  applyFileUrl = "";

  /** 报损凭证附件 */
  certificateFileUrl = "";

  /** 报损部门 */
  department = "";

  /** 明细 */
  detail = [];

  /** 主键 */
  id = undefined;

  /** 质检附件 */
  inspectionFileUrl = "";

  /** 工作流实例id */
  instanceId = "";

  /** 平台编码 */
  platformCode = "";

  /** 平台履行时间 */
  platformFulfilmentTime = "";

  /** 报损原因 */
  reason = "";

  /** 库存分配模式，1：指定平台；2：按订单分配 */
  stockMode = undefined;

  /** 总金额 */
  totalAmountCost = undefined;

  /** 货品总金额 */
  totalPriceCost = undefined;

  /** 总库存成本/报损总金额 */
  totalStorageCost = undefined;

  /** 来源单号 */
  tradeCompanyCode = "";

  /** 来源单号 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StorageDamageMasterPageResponseDto {
  /** 报损申请附件 */
  applyFileUrl = "";

  /** 报损凭证附件 */
  certificateFileUrl = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 报损部门 */
  department = "";

  /** 报损单号 */
  fono = "";

  /** 主键 */
  id = undefined;

  /** 质检附件 */
  inspectionFileUrl = "";

  /** 实例id */
  instanceId = "";

  /** 平台编码 */
  platformCode = "";

  /** 数量 */
  qty = undefined;

  /** 报损原因 */
  reason = "";

  /** sku */
  skuNo = "";

  /**  状态 10:未审核 20:审核通过 30:已拣货 40:已发运 50:已驳回 60: 审核中 */
  status = undefined;

  /** 库存分配模式，1：指定平台；2：按订单分配 */
  stockMode = undefined;

  /** 总金额 */
  totalAmountCost = undefined;

  /** 货品总金额 */
  totalPriceCost = undefined;

  /** 总库存成本 */
  totalStorageCost = undefined;

  /** 来源单号 */
  tradeCompanyCode = "";

  /** 来源单号 */
  tradeCompanyName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StorageDamageMasterSkuInfoResponseDto {
  /** 军团 */
  crops = "";

  /** 物流成本 */
  logAcCost = undefined;

  /** 产品名称 */
  productName = "";

  /** 报损数量 */
  qty = undefined;

  /** sku */
  skuNo = "";

  /** 成本 */
  storageCost = undefined;

  /** 仓库可用库存 */
  userQty = undefined;
}

class StorageMasterUrlUpdateDto {
  /** 报损单号 */
  fono = "";

  /** url地址 */
  url = "";
}

class TaskDto {
  /** 节点编码 */
  nodeKey = "";

  /** 节点名称 */
  nodeName = "";

  /** 任务id */
  taskId = "";
}

class TransferDetailResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 主键 */
  id = undefined;

  /** 图片路径 */
  productImageUrl = "";

  /** 产品标题 */
  productTitle = "";

  /** sku编号 */
  skuNo = "";

  /** 转移数 */
  tranQty = undefined;

  /** 库存转移单号 */
  trno = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class TransferInfoResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** SKU详情 */
  details = [];

  /** 主键 */
  id = undefined;

  /** 工作流实例ID */
  instanceId = "";

  /** 备注 */
  remark = "";

  /** 站点 */
  site = "";

  /** 来源平台编号 */
  sourcePlatformCode = "";

  /** 来源平台名称 */
  sourcePlatformName = "";

  /** 状态 20:审核中 30:已驳回 40:已通过 */
  status = undefined;

  /** 目标平台编号 */
  targetPlatformCode = "";

  /** 目标平台名称 */
  targetPlatformName = "";

  /** 库存转移单号 */
  trno = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class TransferMasterResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 >1:是 */
  deleted = undefined;

  /** 主键 */
  id = undefined;

  /** 工作流实例ID */
  instanceId = "";

  /** 版本号 */
  lockVersion = undefined;

  /** 备注 */
  remark = "";

  /** 站点 */
  site = "";

  /** 来源平台编号 */
  sourcePlatformCode = "";

  /** 来源平台名称 */
  sourcePlatformName = "";

  /** 状态 20:审核中 30:已驳回 40:已通过 */
  status = undefined;

  /** 目标平台编号 */
  targetPlatformCode = "";

  /** 目标平台名称 */
  targetPlatformName = "";

  /** 库存转移单号 */
  trno = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class TransferRequestParamsDto {
  /** 主键 */
  id = undefined;

  /** 工作流实例ID */
  instanceId = "";

  /** 备注 */
  remark = "";

  /** 站点 */
  site = "";

  /** sku编号 */
  skuNo = "";

  /** 来源平台编号 */
  sourcePlatformCode = "";

  /** 状态 20:审核中 30:已驳回 40:已通过 */
  status = "";

  /** 目标平台编号 */
  targetPlatformCode = "";

  /** 库存转移单号 */
  trno = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class TransferSkuRequestParamDto {
  /** 批次号 */
  batchNo = "";

  /** 数量 */
  qty = undefined;

  /** sku编号 */
  skuNo = "";
}

class TransitStockResponseDto {
  /** 调拨发运时间 */
  deliveryTime = "";

  /** 平台编号 */
  platformCode = "";

  /** 在途数量 */
  qty = undefined;

  /** 来源单号 */
  sourceNo = "";

  /** 来源类型 20:退货单 30:交货单 50:调拨单 90:公司间交易 */
  sourceType = undefined;
}

class WalmartStockResponseDto {
  /** 军团名称 */
  corpsName = "";

  /** 组织编号 */
  organizeCode = "";

  /** 组织名称 */
  organizeName = "";

  /** 产品名称 */
  productName = "";

  /** 母仓库编号 */
  rootWarehouseCode = "";

  /** 母仓库名称 */
  rootWarehouseName = "";

  /** sku */
  sku = "";

  /** SPU编号 */
  spu = "";

  /** 在库数量 */
  stockQty = undefined;

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 子库编号 */
  warehouseCode = "";

  /** 子库名称 */
  warehouseName = "";
}

class WarehouseChildAttributeRequestDto {
  /** 属性编号 */
  attributeCode = "";

  /** 属性名称 */
  attributeName = "";

  /** 主键 */
  id = undefined;

  /** 子仓库编号 */
  warehouseCode = "";
}

class WarehouseChildAttributeResponseDto {
  /** 属性编号 */
  attributeCode = "";

  /** 属性名称 */
  attributeName = "";

  /** 主键 */
  id = undefined;

  /** 子仓库编号 */
  warehouseCode = "";

  /** 子仓库名称 */
  warehouseName = "";
}

class WarehouseChildRequestDto {
  /** 主键 */
  id = undefined;

  /** 是否指定库位 0-是 1-否 */
  isPosition = undefined;

  /** 子库平台 */
  platformStr = "";

  /** 母仓库编号 */
  rootWarehouseCode = "";

  /** 禁止批次标识 0:否1:是 */
  stopBatchFlag = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商idName */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 子库属性 */
  warehouseChildAttributeRequestDtoList = [];

  /** 子仓库编号 */
  warehouseCode = "";

  /** 子仓库名称 */
  warehouseName = "";

  /** 子仓英文名称 */
  warehouseNameEn = "";
}

class WarehouseChildResponseDetailDto {
  /** 区域 */
  area = "";

  /** 是否指定库位 0-是 1-否 */
  isPosition = undefined;

  /** 母仓库编号 */
  rootWarehouseCode = "";

  /** 母仓库名称 */
  rootWarehouseName = "";

  /** 仓库状态  0:停用 1:启用 */
  status = undefined;

  /** 禁止批次标识 0:否1:是 */
  stopBatchFlag = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商idName */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 三方仓编号 */
  thirdWarehouseNo = "";

  /** 仓库类型 10:自营仓 20:FBA仓 30:三方仓 40:工厂仓 50:WFS仓 60:虚拟仓 */
  type = undefined;

  /** 子库属性 */
  warehouseChildAttributeResponseDtoList = [];

  /** 子仓库编号 */
  warehouseCode = "";

  /** 子仓库名称 */
  warehouseName = "";

  /** 子仓英文名称 */
  warehouseNameEn = "";
}

class WarehouseChildResponseDto {
  /** 地址 */
  address = "";

  /** 城市 */
  city = "";

  /** 联系方式 */
  contact = "";

  /** 联系人 */
  contacts = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 负责人 */
  director = "";

  /** 邮箱 */
  email = "";

  /** 主键 */
  id = undefined;

  /** 是否指定库位 0-是 1-否 */
  isPosition = undefined;

  /** 组织编号 */
  organizeCode = "";

  /** 组织名称 */
  organizeName = "";

  /** 子库平台归属 */
  platformStr = "";

  /** 邮编 */
  postcode = "";

  /** 省份 */
  province = "";

  /** 母仓库编号 */
  rootWarehouseCode = "";

  /** 母仓库名称 */
  rootWarehouseName = "";

  /** 母仓库英文名称 */
  rootWarehouseNameEn = "";

  /** 禁止批次标识 0:否1:是 */
  stopBatchFlag = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商idName */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 固定电话 */
  telephone = "";

  /** 三方仓标识 */
  thirdWarehouseFlag = "";

  /** 三方仓编号 */
  thirdWarehouseNo = "";

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 仓库类型 10:自营仓 20:FBA仓 30:三方仓 40:工厂仓 50:WFS仓 60:虚拟仓 */
  type = undefined;

  /** 子库属性 */
  warehouseChildAttributeResponseDtoList = [];

  /** 子仓库编号 */
  warehouseCode = "";

  /** 子仓库名称 */
  warehouseName = "";

  /** 子仓英文名称 */
  warehouseNameEn = "";
}

class WarehouseChildResponseRpcDto {
  /** 是否指定库位 0-是 1-否 */
  isPosition = undefined;

  /** 母仓库编号 */
  rootWarehouseCode = "";

  /** 禁止批次标识 0:否1:是 */
  stopBatchFlag = undefined;

  /** 子仓库编号 */
  warehouseCode = "";

  /** 子仓库名称 */
  warehouseName = "";

  /** 子仓英文名称 */
  warehouseNameEn = "";
}

class WarehouseCostApprovalFinanceReceptionDto {
  /** 仓储费用明细 */
  warehouseCostDetailCreateRequestDtosList = [];

  /** 费用编号 */
  wcno = "";
}

class WarehouseCostApprovalPassReceptionDto {
  /** 财务附件 */
  financeFile = "";

  /** 付款银行编号 */
  paymentBankCode = "";

  /** 付款银行名称 */
  paymentBankName = "";

  /** 付款时间 */
  paymentDate = "";

  /** status */
  status = undefined;

  /** 费用编号 */
  wcno = "";
}

class WarehouseCostDetailCreateFinanceRequestDto {
  /** 费用用途备注 */
  costPurposeRemark = "";

  /** 抵扣税额 */
  deductTaxAmount = undefined;

  /** id */
  id = undefined;
}

class WarehouseCostDetailDetailResponseDto {
  /** 受益部门 */
  benefitDepartment = "";

  /** 费用金额 */
  costAmount = undefined;

  /** 费用结束时间 */
  costEndDate = "";

  /** 费用附件 */
  costFile = "";

  /** 费用选项编号/费用类别 */
  costOptionCode = "";

  /** 费用用途备注 */
  costPurposeRemark = "";

  /** 费用开始时间 */
  costStartDate = "";

  /** 抵扣税额 */
  deductTaxAmount = undefined;

  /** id */
  id = undefined;

  /** 收款人开户行 */
  payeeBankName = "";

  /** 收款人银行账户 */
  payeeBankNumber = "";

  /** 人民币金额 */
  rmbAmount = undefined;
}

class WarehouseCostDetailModel {
  /** 受益部门 */
  benefitDepartment = "";

  /** 受益部门名称 */
  benefitDepartmentName = "";

  /** 费用金额 */
  costAmount = undefined;

  /** 费用结束时间 */
  costEndDate = "";

  /** 费用附件 */
  costFile = "";

  /** 费用选项编号 */
  costOptionCode = "";

  /** 费用选项名称 */
  costOptionName = "";

  /** 费用用途备注 */
  costPurposeRemark = "";

  /** 费用开始时间 */
  costStartDate = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 抵扣税额 */
  deductTaxAmount = undefined;

  /** 删除标识 */
  deleted = undefined;

  /** 主键 */
  id = undefined;

  /** 收款人开户行 */
  payeeBankName = "";

  /** 收款人银行账户 */
  payeeBankNumber = "";

  /** 收款人名称 */
  payeeName = "";

  /** 备注 */
  remark = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 仓库费用编号 */
  wcno = "";
}

class WarehouseCostMasterDetailResponseDto {
  /** 费用结束时间 */
  costEndDate = "";

  /** 费用开始时间 */
  costStartDate = "";

  /** 币种 */
  currency = "";

  /** 财务附件/水单附件 */
  financeFile = "";

  /** 工作流id */
  instanceId = "";

  /** 支付类型 10:对公 20:对私 */
  payType = undefined;

  /** 付款银行编号 */
  paymentBankCode = "";

  /** 付款银行名称 */
  paymentBankName = "";

  /** 付款时间 */
  paymentDate = "";

  /** 是否预付款  0:否1:是 */
  prepaymentFlag = undefined;

  /** 备注 */
  remark = "";

  /** 供应商编码 */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 费用金额 */
  totalCostAmount = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓储费用明细 */
  warehouseDetailList = [];

  /** 仓库名称 */
  warehouseName = "";

  /** 费用编号 */
  wcno = "";
}

class WarehouseCostMasterPageResponseDto {
  /** 费用结束时间 */
  costEndDate = "";

  /** 费用开始时间 */
  costStartDate = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 主键 */
  id = undefined;

  /** 工作流id */
  instanceId = "";

  /** 支付类型 10:对公 20:对私 */
  payType = undefined;

  /** 是否预付款  0:否1:是 */
  prepaymentFlag = undefined;

  /** 备注 */
  remark = "";

  /** 人民币金额 */
  rmbAmount = undefined;

  /** 状态 10:审批中 20:待付款 30:已付款 40:审批驳回 */
  status = undefined;

  /** 供应商编码 */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 费用金额 */
  totalCostAmount = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 费用编号 */
  wcno = "";
}

class WarehouseCostModel {
  /** 费用结束时间 */
  costEndDate = "";

  /** 费用开始时间 */
  costStartDate = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 财务附件 */
  financeFile = "";

  /** 主键 */
  id = undefined;

  /** 工作流实例ID */
  instanceId = "";

  /** 支付类型 10:对公 20:对私 */
  payType = undefined;

  /** 付款银行编号 */
  paymentBankCode = "";

  /** 付款银行名称 */
  paymentBankName = "";

  /** 付款时间 */
  paymentDate = "";

  /** 是否预付款  0:否1:是 */
  prepaymentFlag = undefined;

  /** 备注 */
  remark = "";

  /** 人民币金额 */
  rmbAmount = undefined;

  /** 状态 10:审批中 20:待付款 30:已付款 40:审批驳回 */
  status = undefined;

  /** 供应商编码 */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 费用金额 */
  totalCostAmount = undefined;

  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";

  /** 仓库费用编号 */
  wcno = "";
}

class WarehouseCostPushEbsRequestDto {
  /** 申请人 */
  applicant = "";

  /** 审批流程 */
  approvalFlowModel = new ApprovalFlowModel();

  /** 当前审批人 */
  currentApproval = "";

  /** 工号 */
  jobNo = "";

  /** 供应商名称 */
  supplierInfoName = "";

  /** 处理明细 */
  warehouseCostDetailModelList = [];

  /** 仓储费用主体 */
  warehouseCostModel = new WarehouseCostModel();
}

class WarehouseMasterDetailResponseDto {
  /** 地址 */
  address = "";

  /** 发货地址、国家-英文 */
  addressEn = "";

  /** 地址行-英文 */
  addressLineEn = "";

  /** 地址名称-英文 */
  addressNameEn = "";

  /** 区域 */
  area = "";

  /** 城市 */
  city = "";

  /** 城市-英文 */
  cityEn = "";

  /** 联系方式 */
  contact = "";

  /** 联系人 */
  contacts = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除0：否1：是 */
  deleted = undefined;

  /** 负责人 */
  director = "";

  /** 市/镇-英文 */
  districtOrCountyEn = "";

  /** 邮箱 */
  email = "";

  /** 主键 */
  id = undefined;

  /** 组织编号 */
  organizeCode = "";

  /** 组织名称 */
  organizeName = "";

  /** 邮编 */
  postcode = "";

  /** 省份 */
  province = "";

  /** 州、省、直辖市或自治区-英文 */
  provinceEn = "";

  /** 母仓库编号 */
  rootWarehouseCode = "";

  /** 母仓库名称 */
  rootWarehouseName = "";

  /** 仓库英文名称 */
  rootWarehouseNameEn = "";

  /** 状态 0:停用 1:启用 */
  status = undefined;

  /** 禁止批次标识 0:否1:是 */
  stopBatchFlag = undefined;

  /** 固定电话 */
  telephone = "";

  /** 三方仓标识 */
  thirdWarehouseFlag = "";

  /** 三方仓编号 */
  thirdWarehouseNo = "";

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 仓库类型 10:自营仓 20:FBA仓 30:三方仓 40:工厂仓 50:WFS仓 60:虚拟仓 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 子库明细 */
  warehouseChildResponseDtoList = [];
}

class WarehouseMasterRequestDto {
  /** 地址 */
  address = "";

  /** 发货地址、国家-英文 */
  addressEn = "";

  /** 地址行-英文 */
  addressLineEn = "";

  /** 地址名称-英文 */
  addressNameEn = "";

  /** 区域 */
  area = "";

  /** 城市 */
  city = "";

  /** 城市-英文 */
  cityEn = "";

  /** 联系方式 */
  contact = "";

  /** 联系人 */
  contacts = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 负责人 */
  director = "";

  /** 市/镇-英文 */
  districtOrCountyEn = "";

  /** 邮箱 */
  email = "";

  /** 主键 */
  id = undefined;

  /** 组织编号 */
  organizeCode = "";

  /** 邮编 */
  postcode = "";

  /** 省份 */
  province = "";

  /** 州、省、直辖市或自治区-英文 */
  provinceEn = "";

  /** 母仓库编号 */
  rootWarehouseCode = "";

  /** 母仓库名称 */
  rootWarehouseName = "";

  /** 仓库英文名称 */
  rootWarehouseNameEn = "";

  /** 状态 0:停用 1:启用 */
  status = undefined;

  /** 固定电话 */
  telephone = "";

  /** 三方仓标识 */
  thirdWarehouseFlag = "";

  /** 三方仓编号 */
  thirdWarehouseNo = "";

  /** 仓库类型 10:自营仓 20:FBA仓 30:三方仓 40:工厂仓 50:WFS仓 60:虚拟仓 */
  type = undefined;

  /** 子仓信息 */
  warehouseChildRequestDtoList = [];
}

class WarehouseMasterResponseRpcDto {
  /** 地址 */
  address = "";

  /** 发货地址、国家-英文 */
  addressEn = "";

  /** 地址行-英文 */
  addressLineEn = "";

  /** 地址名称-英文 */
  addressNameEn = "";

  /** 区域 */
  area = "";

  /** 城市 */
  city = "";

  /** 城市-英文 */
  cityEn = "";

  /** 联系方式 */
  contact = "";

  /** 联系人 */
  contacts = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除0：否1：是 */
  deleted = undefined;

  /** 负责人 */
  director = "";

  /** 市/镇-英文 */
  districtOrCountyEn = "";

  /** 邮箱 */
  email = "";

  /** 主键 */
  id = undefined;

  /** 是否指定库位 0-是 1-否 */
  isPosition = undefined;

  /** 组织编号 */
  organizeCode = "";

  /** 邮编 */
  postcode = "";

  /** 省份 */
  province = "";

  /** 州、省、直辖市或自治区-英文 */
  provinceEn = "";

  /** 母仓库编号 */
  rootWarehouseCode = "";

  /** 母仓库名称 */
  rootWarehouseName = "";

  /** 仓库英文名称 */
  rootWarehouseNameEn = "";

  /** 状态 0:停用 1:启用 */
  status = undefined;

  /** 禁止批次标识 0:否1:是 */
  stopBatchFlag = undefined;

  /** 供应商编号 */
  supplier = "";

  /** 固定电话 */
  telephone = "";

  /** 三方仓编号 */
  thirdWarehouseNo = "";

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 仓库类型 10:自营仓 20:FBA仓 30:三方仓 40:工厂仓 50:WFS仓 60:虚拟仓 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class WarehouseOrganizeRequestDto {
  /** 主键 */
  id = undefined;

  /** 组织编号 */
  organizeCode = "";

  /** 组织名称 */
  organizeName = "";

  /** 状态 0:停用 1:启用 */
  status = undefined;

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class WarehouseOrganizeResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除0：否1：是 */
  deleted = undefined;

  /** 主键 */
  id = undefined;

  /** 组织编号 */
  organizeCode = "";

  /** 组织名称 */
  organizeName = "";

  /** 状态 0:停用 1:启用 */
  status = undefined;

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class WarehouseOrganizeRpcResponseDto {
  /** 组织编号 */
  organizeCode = "";

  /** 组织名称 */
  organizeName = "";

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class WarehouseParamsDto {
  /** 发货地址、国家-英文 */
  addressEn = "";

  /** 地址行-英文 */
  addressLineEn = "";

  /** 地址名称-英文 */
  addressNameEn = "";

  /** 城市 */
  city = "";

  /** 城市-英文 */
  cityEn = "";

  /** 联系方式 */
  contact = "";

  /** 联系人 */
  contacts = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 负责人 */
  director = "";

  /** 市/镇-英文 */
  districtOrCountyEn = "";

  /** 邮箱 */
  email = "";

  /** 主键 */
  id = undefined;

  /** 是否指定库位 0-是 1-否 */
  isPosition = undefined;

  /** 组织编号 */
  organizeCode = "";

  /** 组织编号多选 */
  organizeCodes = [];

  /** 组织名称 */
  organizeName = "";

  /** 组织名称多选 */
  organizeNames = [];

  /** 子库平台 */
  platformStr = "";

  /** 平台履行时间 */
  platformfulfilmenttime = "";

  /** 邮编 */
  postcode = "";

  /** 省份 */
  province = "";

  /** 州、省、直辖市或自治区-英文 */
  provinceEn = "";

  /** 母仓库编号 */
  rootWarehouseCode = "";

  /** 母仓库编号多选 */
  rootWarehouseCodes = [];

  /** 母仓库名称 */
  rootWarehouseName = "";

  /** 母仓库名称多选 */
  rootWarehouseNames = [];

  /** 状态 0:停用 1:启用 */
  status = undefined;

  /** 禁止批次标识 0:否1:是 */
  stopBatchFlag = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商CodeList */
  supplierCodeList = [];

  /** 供应商idName */
  supplierIdName = "";

  /** 供应商idName列表 */
  supplierIdNameList = [];

  /** 供应商名称 */
  supplierName = "";

  /** 固定电话 */
  telephone = "";

  /** 三方仓标识 */
  thirdWarehouseFlag = "";

  /** 三方仓编号 */
  thirdWarehouseNo = "";

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 仓库类型 10:自营仓 20:FBA仓 30:三方仓 40:工厂仓 50:WFS仓 60:虚拟仓 */
  type = undefined;

  /** 仓库类型 多选 */
  typeList = [];

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 子仓库编号 */
  warehouseCode = "";

  /** 子仓编号多选 */
  warehouseCodes = [];

  /** 子仓库名称 */
  warehouseName = "";

  /** 子仓名称多选 */
  warehouseNames = [];
}

class WarehouseResponseRpcDto {
  /** 地址 */
  address = "";

  /** 发货地址、国家-英文 */
  addressEn = "";

  /** 地址行-英文 */
  addressLineEn = "";

  /** 地址名称-英文 */
  addressNameEn = "";

  /** 区域 */
  area = "";

  /** 城市 */
  city = "";

  /** 城市-英文 */
  cityEn = "";

  /** 联系方式 */
  contact = "";

  /** 联系人 */
  contacts = "";

  /** 国家 */
  country = "";

  /** 国家简码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 负责人 */
  director = "";

  /** 市/镇-英文 */
  districtOrCountyEn = "";

  /** 邮箱 */
  email = "";

  /** id */
  id = undefined;

  /** 是否指定库位 0-是 1-否 */
  isPosition = undefined;

  /** 组织编号 */
  organizeCode = "";

  /** 组织名称 */
  organizeName = "";

  /** 组织状态 0:停用 1:启用 */
  organizeStatus = undefined;

  /** 子库平台归属 */
  platformStr = "";

  /** 邮编 */
  postcode = "";

  /** 省份 */
  province = "";

  /** 州、省、直辖市或自治区-英文 */
  provinceEn = "";

  /** 母仓库编号 */
  rootWarehouseCode = "";

  /** 母仓库名称 */
  rootWarehouseName = "";

  /** 仓库英文名称 */
  rootWarehouseNameEn = "";

  /** 仓库状态  0:停用 1:启用 */
  status = undefined;

  /** 禁止批次标识 0:否1:是 */
  stopBatchFlag = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商idName */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 固定电话 */
  telephone = "";

  /** 三方仓标识 */
  thirdWarehouseFlag = "";

  /** 三方仓编号 */
  thirdWarehouseNo = "";

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 仓库类型 10:自营仓 20:FBA仓 30:三方仓 40:工厂仓 50:WFS仓 60:虚拟仓 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 子库属性 */
  warehouseChildAttributeResponseDtoList = [];

  /** 子仓库编号 */
  warehouseCode = "";

  /** 子仓库名称 */
  warehouseName = "";

  /** 子仓英文名称 */
  warehouseNameEn = "";
}

class WarehouseRulesDetailShowDto {
  /** 过滤规则 */
  filterRule = new FilterRuleBean();

  /** 是否启用：1是 0否 */
  isEnable = undefined;

  /** 规则名称 */
  ruleName = "";
}

class WarehouseRulesRequestDto {
  /** 优先类型：time时效   price价格 */
  firstType = "";

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 匹配规则 */
  rules = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;
}

class WarehouseRulesRequestParamsDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 优先类型：time时效   price价格 */
  firstType = "";

  /** id */
  id = undefined;

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 备注 */
  remark = "";

  /** 匹配规则 */
  rules = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class WarehouseShopResponseRpcDto {
  /** 交易主体编号 */
  tradeCompanyCode = "";

  /** 交易主体名称 */
  tradeCompanyName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class XRESULTREC {
  /** allPageidQty */
  allPageidQty = "";

  /** allQty */
  allQty = "";

  /** inventoryCode */
  inventoryCode = "";

  /** pageid */
  pageid = "";

  /** resValue1 */
  resValue1 = undefined;

  /** resValue10 */
  resValue10 = undefined;

  /** resValue2 */
  resValue2 = undefined;

  /** resValue3 */
  resValue3 = undefined;

  /** resValue4 */
  resValue4 = undefined;

  /** resValue5 */
  resValue5 = undefined;

  /** resValue6 */
  resValue6 = undefined;

  /** resValue7 */
  resValue7 = undefined;

  /** resValue8 */
  resValue8 = undefined;

  /** resValue9 */
  resValue9 = undefined;

  /** returnInfor */
  returnInfor = undefined;

  /** returnStatus */
  returnStatus = "";
}

class XRETURNBODYTB {
  /** xreturnBodyTbItem */
  xreturnBodyTbItem = [];
}

class XRETURNBODYTBITEM {
  /** 库存成本 */
  acCost = "";

  /** itemCode */
  itemCode = "";

  /** 物流成本 */
  logAcCost = "";

  /** resValue1 */
  resValue1 = "";

  /** resValue10 */
  resValue10 = undefined;

  /** resValue2 */
  resValue2 = undefined;

  /** resValue3 */
  resValue3 = undefined;

  /** resValue4 */
  resValue4 = undefined;

  /** resValue5 */
  resValue5 = undefined;

  /** resValue6 */
  resValue6 = undefined;

  /** resValue7 */
  resValue7 = undefined;

  /** resValue8 */
  resValue8 = undefined;

  /** resValue9 */
  resValue9 = undefined;
}

class XResultRec {
  /** batchId */
  batchId = "";

  /** extBatchId */
  extBatchId = "";
}

class ZoneBean {
  /** 邮编范围止 */
  postcodeEnd = "";

  /** 邮编范围起 */
  postcodeStart = "";

  /** 目的国家数简码 */
  targetCountryCode = "";
}

class factoryDirectCreateLineSnapShotRequestDto {
  /** 调拨单号 */
  aono = "";

  /** 采购单号 */
  ponoList = [];
}

export const fulfilment = {
  AmazonInventoryMonthlyCanCreateResponseDto,
  ApprovalBeforeRequestDto,
  ApprovalFlowModel,
  ApprovalRequestDto,
  AssigneeDto,
  BatchCreateRequestParamsDto,
  BatchMasterCreateRequestParamDto,
  BatchStockAgeResponseRpcDto,
  BoxRequestDto,
  CurrentTaskDto,
  DeliveryDealRequestDto,
  DeliveryDealRowDetail,
  EbsOutputParameters,
  EbsSkuCostDto,
  EbsSkuCostListDto,
  EbsTransferDataResponseDto,
  FilterRuleBean,
  FulfilmentInRequestDto,
  FulfilmentOutRequestDto,
  FulfilmentResponseRpcDto,
  HistoryFulfilmentInRequestDto,
  IPage,
  InDeliverySendBackCountRequestParamsDto,
  InDeliverySendBackCountResponseRpcDto,
  InDeliverySendBackRequestParamsDto,
  InDeliverySkuLineBoxRequestParamsDto,
  InDeliverySkuLineRequestParamsDto,
  InDeliveryWriteBackDto,
  InDeliveryWriteBackLineDto,
  InDetailCreateRequestDto,
  InDetailPDAReceivingFulRequestDto,
  InPlanAllocationEditRequestDto,
  InPlanCreateRequestParamsDto,
  InPlanDetailCreateRequestParamsDto,
  InPlanDetailOneClickInboundDto,
  InPlanDetailResponseDto,
  InPlanDetailResponseRpcDto,
  InPlanMasterDetailResponseDto,
  InPlanMasterInfoResponseRpcDto,
  InPlanMasterOneClickInboundDto,
  InPlanMasterRequestDto,
  InPlanMasterResponseDto,
  InPlanMasterResponseRpcDto,
  InPlanOmsCreateRequestDto,
  InPlanResponseDto,
  InPlanResponseRpcDto,
  InPlanStatusRequestDto,
  InPlanUpdateRequestDto,
  InPutBoxDetailDto,
  InPutDetailDto,
  InPutPoDetailDto,
  InoutFulfilmentResponseRpcDto,
  InventoryCostPushToEbsRequestDto,
  InventoryCostRequestDto,
  LendDetailResponseDto,
  LendMasterDetailResponseDto,
  LendMasterPageResponseDto,
  LendMasterRequestDto,
  LogisticsReturnCreateInDto,
  LogisticsReturnRecordRequestDto,
  LogisticsReturnRecordResponseDto,
  LogisticsReturnRecordResponseRpcDto,
  LogisticsReverseLabelRequestDto,
  LogisticsReverseLabelResponseDto,
  OmsPackageInfoDetailDto,
  OmsPackageInfoDto,
  OrderApplyOperationRequestDto,
  OrderCreateRequestDto,
  OrderDetailRequestDto,
  OrderUpdateChannelRequestDto,
  OutDetailCreateRequestDto,
  OutInterceptBeforeInfoResponseDto,
  OutPickBoxDetailDto,
  OutPickDetailDto,
  OutPlanCreateRequestParamsDto,
  OutPlanDetailCreateRequestParamsDto,
  OutPlanDetailFulfilmentRequestParamsDto,
  OutPlanDetailPurchaseDto,
  OutPlanDetailResponseDto,
  OutPlanDetailResponseRpcDto,
  OutPlanFulfilmentRequestParamsDto,
  OutPlanMasterCreateRequestRpcDto,
  OutPlanMasterRequestParamsDto,
  OutPlanMasterResponseDetailDto,
  OutPlanMasterResponseDto,
  OutPlanMasterResponseRpcDto,
  OutPlanPoOccupyResponseRpcDto,
  OutPlanSkuBatchCheckRequestDto,
  OutPlanSkuBatchDetailCheckDto,
  OutPlanUpdatePriceRequestDto,
  OutPlanUpdateStatusRequestDto,
  OutReturnDetailRequestDto,
  OutReturnSignRequestDto,
  OutSkuRowDetailDto,
  OutputParametersDTO,
  P_PAGE_INFO,
  P_QUERY_INFO,
  PageInfo,
  PlatformAccountPeriodResponseDto,
  PoOccupyDetail,
  PurchaseReturnCreateRequestDto,
  PurchaseReturnDetailDto,
  PurchaseReturnLineDetailDto,
  PushRequestDto,
  QUERY_ITEM_INFO_TBL,
  QUERY_ITEM_INFO_TBL_ITEM,
  RefundAbleQtyRequestParamsDto,
  Response,
  ResponseDto,
  ShippedAddressDto,
  SkuDetailDto,
  SkuPoLineDetail,
  SplitBoxRequestParamDto,
  StockAdjustmentCreateImportDetailResponseDto,
  StockAdjustmentCreateRequestDto,
  StockAdjustmentDetailCreateRequestDto,
  StockAdjustmentDetailDetailResponseDto,
  StockAdjustmentDetailHandleExceptionRequestDto,
  StockAdjustmentDetailRequestDto,
  StockAdjustmentFulfilmentMasterRequestDto,
  StockAdjustmentHandleExceptionRequestDto,
  StockAdjustmentMasterCreateRequestDto,
  StockAdjustmentMasterDetailResponseDto,
  StockAdjustmentMasterListResponseDto,
  StockAdjustmentMasterRequestParamsDto,
  StockSkuPlatformResponseDto,
  StorageDamageDetailResponseDto,
  StorageDamageMasterDetailResponseDto,
  StorageDamageMasterPageResponseDto,
  StorageDamageMasterSkuInfoResponseDto,
  StorageMasterUrlUpdateDto,
  TaskDto,
  TransferDetailResponseDto,
  TransferInfoResponseDto,
  TransferMasterResponseDto,
  TransferRequestParamsDto,
  TransferSkuRequestParamDto,
  TransitStockResponseDto,
  WalmartStockResponseDto,
  WarehouseChildAttributeRequestDto,
  WarehouseChildAttributeResponseDto,
  WarehouseChildRequestDto,
  WarehouseChildResponseDetailDto,
  WarehouseChildResponseDto,
  WarehouseChildResponseRpcDto,
  WarehouseCostApprovalFinanceReceptionDto,
  WarehouseCostApprovalPassReceptionDto,
  WarehouseCostDetailCreateFinanceRequestDto,
  WarehouseCostDetailDetailResponseDto,
  WarehouseCostDetailModel,
  WarehouseCostMasterDetailResponseDto,
  WarehouseCostMasterPageResponseDto,
  WarehouseCostModel,
  WarehouseCostPushEbsRequestDto,
  WarehouseMasterDetailResponseDto,
  WarehouseMasterRequestDto,
  WarehouseMasterResponseRpcDto,
  WarehouseOrganizeRequestDto,
  WarehouseOrganizeResponseDto,
  WarehouseOrganizeRpcResponseDto,
  WarehouseParamsDto,
  WarehouseResponseRpcDto,
  WarehouseRulesDetailShowDto,
  WarehouseRulesRequestDto,
  WarehouseRulesRequestParamsDto,
  WarehouseShopResponseRpcDto,
  XRESULTREC,
  XRETURNBODYTB,
  XRETURNBODYTBITEM,
  XResultRec,
  ZoneBean,
  factoryDirectCreateLineSnapShotRequestDto,
};
